module.exports = __webpack_public_path__ + "static/og-image-b778bc5e43ff2c215c96e52f0b2013dc.jpg";